import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteComponent } from '@app/route/route.component';
import { HeaderService } from '@app/service/header/header.service';
import { UserService } from '@app/service/user-service/user.service';
import { ResolveType, StateService } from '@app/service/state/state.service';

@Component({
  selector: 'no-rejected',
  templateUrl: './no-rejected.component.html',
  styleUrls: ['./no-rejected.component.scss'],
})
export class NoRejectedComponent extends RouteComponent {
  loading: boolean = false;
  navigationInProgress: boolean = false;

  constructor(
    protected router: Router,
    protected route: ActivatedRoute,
    protected stateService: StateService,
    protected headerService: HeaderService,
    private userService: UserService
  ) {
    super(router, route, stateService, headerService);
  }

  async handleCtaClick(): Promise<void> {
    this.navigationInProgress = true;
    try {
      if (this.state.interruptionDetails?.cancelUrlOverridesCta) {
        const resp = await this.userService.cancelPayment();
        if (resp.success) {
          window.location.href = this.state.merchantUrls?.onCancelUrl;
        }
      } else {
        await this.resolveInterruption(ResolveType.CTA);
      }
    } catch (error) {
      console.log(error);
    }
    this.navigationInProgress = false;
  }

  async handleCtaBlackClick(): Promise<void> {
    this.navigationInProgress = true;
    try {
      if (this.state.interruptionDetails?.cancelUrlOverridesCta) {
        const resp = await this.userService.cancelPayment();
        if (resp.success) {
          window.location.href = this.state.merchantUrls?.onCancelUrl;
        }
      } else {
        await this.resolveInterruption(ResolveType.CTA_BLACK);
      }
    } catch (error) {
      console.log(error);
    }
    this.navigationInProgress = false;
  }
}
